const HelmetFactory = {
    SEARCH_DETAILED: (props) => {
        return {
            title: props.t('common:appTitleSearchDetailed', { filters: props.filtersTitleString }),
            meta: props.t('common:appMetaDescriptionSearchDetailed')
        };
    },
    SEARCH_LIST: (props) => {
        return {
            title: props.t('common:appTitleSearch', { filters: props.filtersTitleString }),
            meta: props.t('common:appMetaDescriptionSearch')
        };
    },
    VEHICLE_DETAILS: (props) => {
        return props.vehicleName ? {
            title: props.t('common:appTitleVehicleDetailed', { vehicleName: props.vehicleName }),
            meta: props.t('common:appMetaDescriptionVehicleDetailed', { vehicleName: props.vehicleNameFull }),
            ogTitle: props.t('common:appTitleVehicleDetailed', { vehicleName: props.vehicleName }),
            ogDescription: props.t('common:appMetaDescriptionVehicleDetailed', { vehicleName: props.vehicleNameFull }),
            ogImage: props.ogImage
        } : {};
    },
    // Autobahn redesign — SRP (/search-next): title/meta + canonical.
    SEARCH_NEXT: (props) => ({
        title: props.t('common:appTitleSearch', { filters: props.filtersTitleString || '' }),
        meta: props.t('common:appMetaDescriptionSearch'),
        canonical: props.canonical,
    }),
    // Autobahn redesign — CDP (/search-next/vehicle/:id): title/meta/OG + canonical + JSON-LD
    // (Vehicle/Offer/AggregateRating). The page supplies the resolved values + the structured data.
    VEHICLE_DETAILS_NEXT: (props) => props.vehicleName
        ? {
            title: props.t('common:appTitleVehicleDetailed', { vehicleName: props.vehicleName }),
            meta: props.t('common:appMetaDescriptionVehicleDetailed', { vehicleName: props.vehicleNameFull }),
            ogTitle: props.t('common:appTitleVehicleDetailed', { vehicleName: props.vehicleName }),
            ogDescription: props.t('common:appMetaDescriptionVehicleDetailed', { vehicleName: props.vehicleNameFull }),
            ogImage: props.ogImage,
            canonical: props.canonical,
            jsonLd: props.jsonLd,
        }
        : {},
    DEFAULT: () => ({})
};
export default HelmetFactory;
